// Directus reads/writes of a single article used by the article editor page.
// Moved out of Article.js without changing requests, fallbacks or error messages.
import { directusAPI } from '../../../api';

/**
 * PATCH /items/articles/:id with readable error messages.
 */
export const patchArticle = async (id, token, articleData) => {
  try {
    const response = await directusAPI.patch(`/items/articles/${id}`, articleData, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(`Error saving article: ${error.response.data.errors?.[0]?.message || error.response.data.message || 'Unknown server error'}`);
    } else if (error.request) {
      throw new Error('Error saving article: No response received from server');
    } else {
      throw new Error(`Error saving article: ${error.message}`);
    }
  }
};

export const fetchToneOfVoiceFromDirectus = async (articleId, token) => {
  try {
    const response = await directusAPI.get(`/items/articles/${articleId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data.toneOfVoice || 'friendly';
  } catch (error) {
    console.error('Error fetching tone of voice:', error);
    return 'friendly';
  }
};

export const fetchComplexityFromDirectus = async (articleId, token) => {
  try {
    const response = await directusAPI.get(`/items/articles/${articleId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data.fog_index || 'fog index: 10';
  } catch (error) {
    console.error('Error fetching complexity:', error);
    return 'fog index: 10';
  }
};

export const fetchLanguageFromDirectus = async (articleId, token) => {
  try {
    const response = await directusAPI.get(`/items/articles/${articleId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data.language || 'polish';
  } catch (error) {
    console.error('Error fetching language:', error);
    return 'polish';
  }
};

export const fetchContentTypeFromDirectus = async (articleId, token) => {
  try {
    const response = await directusAPI.get(`/items/articles/${articleId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data.content_type || '';
  } catch (error) {
    console.error('Error fetching content type:', error);
    return '';
  }
};
// Implement this function to fetch keywords from Directus
export const fetchKeywordsFromDirectus = async (articleId, token) => {
  try {
    const response = await directusAPI.get(`/items/articles/${articleId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data.keywords || [];
  } catch (error) {
    console.error('Error fetching keywords:', error);
    return [];
  }
};

// Implement this function to fetch sources from Directus
export const fetchSourcesFromDirectus = async (articleId, token) => {
  try {
    const response = await directusAPI.get(`/items/articles/${articleId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data.sources || [];
  } catch (error) {
    console.error('Error fetching sources:', error);
    return [];
  }
};

/**
 * linked_datasets given as a plain id list -> dataset records (one GET per id).
 */
export const fetchDatasetsByIds = async (datasetIds) => {
  const token = localStorage.getItem('directus_token');
  const datasetPromises = datasetIds.map(datasetId =>
    directusAPI.get(`/items/data_sets/${datasetId}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
  );

  const responses = await Promise.all(datasetPromises);
  return responses.map(response => response.data.data);
};
